<div id="vtz-main-wrapper" class="vtz-main-wrapper">
  <div id="vtz-main-container" class="vtz-main-container vtz-main-container--ballot vtz-main-container--tall">
    <div id="vtz-title-section" class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main id="vtz-success-code-wrapper" class="vtz-success-code__wrapper">
      <h2 id="vtz-success-code-text" class="vtz-h1 vtz-text--wide vtz-text--center" i18n>
      Your session has ended.</h2><br>
      <a href="{{startPath}}" id="vtz-success-code-subtext2" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space vtz-link" i18n>
        {{this.returnToPage}}
      </a>
    </main>
  </div>
</div>
